import React from 'react';

import {ConnectorSizing, JoinerDomainVisualization, SharedDomainParams} from 'antibodies/AntibodyTypedefs';
import AntibodyPathLinker, {
  ArcDirection,
  ArcSize,
  PathParameter,
  PathParameterType,
} from 'antibodies/visualization/AntibodyPathLinker';

export type AntibodyJoinerProps = SharedDomainParams & {
  color: string;
  domainVisualization: JoinerDomainVisualization;
  connectorSizing: ConnectorSizing;
};

/**
 * A joiner domain is a U-shaped line.
 * This is an SVG component, so all units are 'abstract user units', relative to the SVG viewbox.
 * @param domainVisualization The visualization for the joiner domain
 * @param connectorSizing The sizing params for this format's connectors
 * @param color The color of the line
 * @param proteinId The API ID of the protein entity associated with this domain. If passed, the joiner will
 *                  be given a SmartChip-style popover with metadata about the protein.
 */
export default function AntibodyJoiner({
  domainVisualization,
  color,
  proteinId,
  inaccessible,
  label,
  showPopovers,
  connectorSizing,
  antibodyId,
}: AntibodyJoinerProps): JSX.Element {
  const {length, width} = domainVisualization;

  const pathParameters: Array<PathParameter> = [
    {type: PathParameterType.LINE, dx: 0, dy: length},
    {
      type: PathParameterType.ARC,
      rx: width / 2,
      ry: width / 2,
      dx: width,
      dy: 0,
      rotation: 0,
      arcSize: ArcSize.SMALL,
      direction: ArcDirection.COUNTER_CLOCKWISE,
    },
    {type: PathParameterType.LINE, dx: 0, dy: -length},
  ];
  return (
    <AntibodyPathLinker
      pathParameters={pathParameters}
      color={color}
      proteinId={proteinId}
      inaccessible={inaccessible}
      label={label}
      showPopovers={showPopovers}
      connectorSizing={connectorSizing}
      antibodyId={antibodyId}
    />
  );
}
